<template>
  <v-container>
    <v-btn color="primary" outlined :to="{ name: 'AdminYearCreate' }" router> Create Year </v-btn>
    <v-divider class="my-4"></v-divider>
    <!-- Data Table -->
    <v-data-table-server
      v-model:items-per-page="pagination.limit"
      :search="pagination.q"
      :items="years"
      :headers="headers"
      :items-length="count"
      :loading="loading"
      item-key="id"
      @update:options="handleLimitChange">
      <template v-slot:[`item.action`]="{ item }">
        <v-btn
          :to="{ name: 'AdminYearEdit', params: { yearId: item.id } }"
          router
          small
          color="primary">
          Edit
        </v-btn>
      </template>
      <template v-slot:top>
        <v-text-field
          v-model="pagination.q"
          class="ma-2"
          density="compact"
          placeholder="Search year..."
          hide-details></v-text-field>
      </template>
    </v-data-table-server>
  </v-container>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { IPaginationDTO, PaginationDTO } from '@/dtos';
import { useYearStore } from '@/stores';
import type { VDataTableServer } from 'vuetify/components';

const yearStore = useYearStore();
const pagination = ref<IPaginationDTO>(new PaginationDTO());

const { data: yearData, isLoading: isLoadingYears } = yearStore.getYearsQuery(pagination);

const loading = computed(() => isLoadingYears.value);
const years = computed(() => yearData.value?.data);
const count = computed(() => yearData.value?.count ?? 0);
const headers = [
  { title: 'Year', key: 'year' },
  { title: 'Theme', key: 'theme' },
  { title: 'Dates', key: 'dates' },
  { title: 'Edit', key: 'action' },
];

const handleLimitChange = (value: VDataTableServer) => {
  pagination.value.buildPagination(value);
};
</script>

<style scoped></style>
